// @TODO <HEALTH2019>
// Added $rootScope, healthInsuranceSharedService, healthInsuranceService
App.controller('HealthInsuranceFormCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'insuranceService', 'statesService', '$filter', 'profileService', 'dataUser', '$q', '$rootScope', 'healthInsuranceService', 'popUpService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, insuranceService, statesService, $filter, profileService, dataUser, $q, $rootScope, healthInsuranceService, popUpService) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja (dane i oświadczenia)';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.healthInsurance.package';
    $scope.$emit('link', $scope.link);

    $scope.data = {};

    $scope.package = $scope.stateParams.package;
    $scope.data.benefit = $scope.package;

    if (!$scope.package) {
        $state.go('root.home.healthInsurance.package');
    }

    $scope.packageWithRehabilitation = false;
    $scope.pricePackage = 0;
    $scope.namePackage = '';
    if ($scope.package) {
        $scope.packageWithRehabilitation = typeof $scope.package.selectedRehabilitation !== 'undefined' && $scope.package.selectedRehabilitation;
        $scope.pricePackage = $scope.packageWithRehabilitation ?
            $scope.package.summaryPrice + $scope.package.rehabilitationPrice :
            $scope.package.summaryPrice;
        $scope.namePackage = $scope.packageWithRehabilitation ?
            $scope.package.groupName + ' - ' + $scope.package.name + ' + Rehabilitacja' :
            $scope.package.groupName + ' - ' + $scope.package.name;
    }

    if ($scope.data.benefit) {
        delete $scope.data.benefit.creationTime;
        delete $scope.data.benefit.benefitGroup.creationTime;
    }

    $scope.userData = JSON.parse(window.sessionStorage.getItem('userObject'));

    $scope.data.person = $scope.userData.person;
    delete $scope.data.person.creationTime;


    if($scope.data.person.identifierType == null || $scope.data.person.identifierType === 'undefined') {

        $scope.data.person.citizenshipType = 'POLISH';
        $scope.data.person.identifierType = 'PESEL';

    }

    //console.log("sessionData", $scope.userData.person);
    //console.log("data.person", $scope.data.person);


    if ($scope.userData.person.address) {
        $scope.data.person.address = $scope.userData.person.address;
        delete $scope.data.person.address.creationTime;
        $scope.selectedItemLocalization = $scope.userData.person.address.city;
    }

    $scope.requiredStatementsWitDeductionFromSalary = [
        {
            list: [
                {
                    codeName: ['deductionConsent'],
                    text: '1. Proszę o comiesięczne potrącenie z mojego wynagrodzenia (oraz innych świadczeń związanych z pracą/zleceniem) wartości wybranego przeze mnie pakietu w TU Zdrowie SA.'
                },
                {
                    codeName: ['acceptsPersonalDataProcessing','knowsInformationObligation','acceptsAccessingInformationAboutCircumstances'],
                    text: '2. Wyrażam zgodę na przetwarzanie przez Towarzystwo Ubezpieczeń ZDROWIE S.A. moich danych osobowych, w tym danych o stanie zdrowia w celu wykonywania umowy ubezpieczenia.<br>' +
                        '3. Zapoznałem/zapoznałam się z <a href="'+$rootScope.CONFIGURATOR.healthInsurance.dataProcessingAgreementFileUrl+'" target="_blank">' +
                        'treścią obowiązku informacyjnego' +
                        '</a> TU ZDROWIE S.A.<br>' +
                        '4. Wyrażam zgodę na uzyskiwanie przez Towarzystwo Ubezpieczeń ZDROWIE S.A. w pełnym zakresie informacji o okolicznościach związanych z ustaleniem prawa do świadczenia z zawartej umowy ubezpieczenia i wysokością tego świadczenia, w tym wszelkich informacji i dokumentacji dotyczących stanu mojego zdrowia oraz świadczeniach zdrowotnych z których korzystałem od każdego lekarza, u którego leczyłem(am) się lub zasięgałem(am) porady medycznej, a także we wszystkich placówkach medycznych, które udzielały mi usług medycznych, zgodnie z art. 38. Ustawy o działalności ubezpieczeniowej i reasekuracyjnej (Dz.U. 2015 poz. 1844 z późn. zmianami).',
                }
            ]
        }
    ];

// @TODO <HEALTH2019>
    $scope.requiredStatements = [
        {
            list: [
                {
                    codeName: ['acceptsPersonalDataProcessing','knowsInformationObligation','acceptsAccessingInformationAboutCircumstances'],
                    text: '1. Wyrażam zgodę na przetwarzanie przez Towarzystwo Ubezpieczeń ZDROWIE S.A. moich danych osobowych, w tym danych o stanie zdrowia w celu wykonywania umowy ubezpieczenia.<br>' +
                        '2. Zapoznałem/zapoznałam się z <a href="'+$rootScope.CONFIGURATOR.healthInsurance.dataProcessingAgreementFileUrl+'" target="_blank">' +
                        'treścią obowiązku informacyjnego' +
                        '</a> TU ZDROWIE S.A.<br>' +
                        '3. Wyrażam zgodę na uzyskiwanie przez Towarzystwo Ubezpieczeń ZDROWIE S.A. w pełnym zakresie informacji o okolicznościach związanych z ustaleniem prawa do świadczenia z zawartej umowy ubezpieczenia i wysokością tego świadczenia, w tym wszelkich informacji i dokumentacji dotyczących stanu mojego zdrowia oraz świadczeniach zdrowotnych z których korzystałem od każdego lekarza, u którego leczyłem(am) się lub zasięgałem(am) porady medycznej, a także we wszystkich placówkach medycznych, które udzielały mi usług medycznych, zgodnie z art. 38. Ustawy o działalności ubezpieczeniowej i reasekuracyjnej (Dz.U. 2015 poz. 1844 z późn. zmianami).',
                },
            ]
        }
    ];

    $scope.optionalStatements = [
        {
            name: 'Zgoda marketingowa',
            list: [
                {
                    codeName: 'acceptsProcessingDataForMarketingPurposes',
                    text: 'Wyrażam zgodę, aby moje dane osobowe były przetwarzane przez Towarzystwo Ubezpieczeń ZDROWIE S.A., w celach marketingowych, w tym poprzez profilowanie w celu określenia preferencji lub potrzeb w zakresie produktów ubezpieczeniowych i innych produktów finansowych, oraz w celu przedstawienia odpowiedniej oferty.',
                },

            ]
        },
        {
            name: 'Zgoda na kierowanie komunikacji marketingowej',
            description: 'Wyrażam zgodę na otrzymywanie od Towarzystwo Ubezpieczeń ZDROWIE S.A. informacji handlowo – marketingowych z użyciem urządzeń telekomunikacyjnych i tzw. automatycznych systemów wywołujących, wybierając jako formę kontaktu:',
            list: [
                {
                    codeName: 'acceptsMarketingElectronicMessages',
                    text: 'Wiadomości elektroniczne (e-mail, SMS/MMS, serwisy internetowe, w tym portale społecznościowe)',
                },
                {
                    codeName: 'acceptsMarketingCalls',
                    text: 'Połączenia głosowe (rozmowa telefoniczna, komunikaty głosowe IVR)',
                },
            ]
        }
    ];
// @TODO </HEALTH2019>

    if ($scope.stateParams.branch) {
        $scope.data.branch = $scope.stateParams.branch.name;
    }

    $scope.data.partner = {};
    $scope.data.children = [];

    // $scope.$watchGroup(['children.identifier', 'children.birthdate'], function () {
    //     if ($scope.data.children.citizenshipType === 'POLISH') {
    //         if ($filter('isOver16FromIdentifier')($scope.data.children.identifier)) {
    //             // dodaj pole z mailem
    //         } else {
    //             // ukryj pole z mailem
    //         }
    //     } else {
    //         if ($filter('isOver16FromBirthdate')($scope.data.children.birthdate)) {
    //             // dodaj pole z mailem
    //         } else {
    //             // ukryj pole z mailem
    //         }
    //     }
    // });

    $scope.accept = function() {
        console.log($scope.form);
        $scope.form.$setSubmitted();
        $scope.register($scope.form);
    }

    function checkDuplicatedIdentifiers(data) {

        let identifiers = [];
        if (data.person.identifierType && data.person.identifier) {
            identifiers.push(data.person.identifier);
        }

        if (data.partner && data.partner.nationality === 'POLISH' && data.partner.identifier) {
            identifiers.push(data.partner.identifier);
        }

        identifiers = _.concat(identifiers, _.map(_.filter(data.children, {nationality: 'POLISH'}), 'identifier'));
        return Object.entries(_.countBy(identifiers))
            .reduce((acc, [key, val]) => {
                return val > 1 ? acc.concat(key) : acc
            }, [])
            .map(Number)
    }

    $scope.register = function(form) {
        if (!form.$valid) {
            return 0;
        }

        let duplicatedIdentifiers = checkDuplicatedIdentifiers($scope.data);
        if (duplicatedIdentifiers.length > 0) {
            $scope.showPopUp('', '', 'Zgłaszane osoby mają ten sam nr PESEL ' +  _.join(duplicatedIdentifiers, ', ') + ' - sprawdź wypełnione pola');
            return 0;
        }

// @TODO <HEALTH2019>
        var checkedRequiredStatementsCount = 0;
        var requiredAmountOfCheckedRequiredStatements = 0;

        var requiredStatements = $rootScope.CONFIGURATOR.healthInsurance.separateDeductionFromSalary ? $scope.requiredStatementsWitDeductionFromSalary : $scope.requiredStatements;

        angular.forEach(requiredStatements, function (statementsGroup) {
            requiredAmountOfCheckedRequiredStatements = requiredAmountOfCheckedRequiredStatements + statementsGroup.list.length;

            angular.forEach(statementsGroup.list, function (statement) {
                if (statement.checked) {
                    checkedRequiredStatementsCount++;
                }
            });
        });

        if (!isRequiredStatementsChecked(requiredStatements)) {
            $scope.showPopUp('', 'Zaakceptuj oświadczenia', 'Aby zatwierdzić deklarację zaakceptuj wymagane oświadczenia.');
            return 0;
        }
// @TODO </HEALTH2019>

        var $data = angular.copy($scope.data);
        if ($rootScope.CONFIGURATOR.healthInsurance.separateDeductionFromSalary) {
            $data.deductionConsent = true;
            $data.deductionConsentDate = new Date();
        }

        var childrenLength = Object.keys($data.children).length;
        var partnerLength = ($data.partner && Object.keys($data.partner).length) ? 1 : 0;

        if ($scope.package.partner && !$scope.package.children) {
            if (childrenLength + partnerLength < 1) {
                $scope.showPopUp('', 'Dodaj partnera', 'Aby zatwierdzić deklarację musisz dodać partnera lub dziecko.');
                return 0;
            }
        } else if ($scope.package.partner && $scope.package.children) {
            if (childrenLength + partnerLength < 2) {
                $scope.showPopUp('', 'Dodaj osoby', 'Aby zatwierdzić deklarację musisz dodać co najmniej 2 osoby.');
                return 0;
            }
        }

        var len = Object.keys($data.children).length;
        if (len) {
            for (var a = 0; a < len; a++) {
                if ($data.children[a].member === 'CHILD') {
                    if ($data.children[a].nationality === 'POLISH') {
                        if ($filter('isOver26FromIdentifier')($data.children[a].identifier)) {
                            $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.', '');
                            return 0;
                        }
                    } else {
                        if ($filter('isOver26FromBirthdate')($data.children[a].birthdate)) {
                            $scope.showPopUp('', 'Błędne dane', 'Nie możesz dodać dziecka, który ma powyżej 26 lat.', '');
                            return 0;
                        }
                    }
                }
            }
        }

        var isPartnerTypeDeclaration = $data.benefit.groupName === 'Partnerski';
        var isFamilyTypeDeclaration = $data.benefit.groupName === 'Rodzinny';

        if (Object.keys($data.partner).length) {
            $data.partner.identifierType = ($data.partner.nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
            $data.partner.identifier = ($data.partner.nationality !== 'POLISH') ? $data.partner.id : $data.partner.identifier;
            $data.partner.birthdate = ($data.partner.nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.partner.birthdate) : $filter('getDateFromIdentifier')($data.partner.identifier);
            $data.partner.citizenshipType = $data.partner.nationality;
            $data.partner.address.city = $data.partner.selectedItemLocalization;

            delete $data.partner.selectedItemLocalization;
            delete $data.partner.nationality;
            delete $data.partner.id;
            delete $data.partner.sameAddress;
        } else {
            delete $data.partner;
        }

        var len = Object.keys($data.children).length;
        if (len) {
            for (var a = 0; a < len; a++) {

                // if ($scope.children[a].citizenshipType === 'POLISH') {
                //     if ($filter('isAdultFromIdentifier')($scope.children[a].identifier)) {
                //         $data.children[a].type = 'ADULT_CHILD';
                //     }
                // } else {
                //     if ($filter('isAdultFromBirthdate')($scope.children[a].birthdate)) {
                //         $data.children[a].type = 'ADULT_CHILD';
                //     }
                // }

                if (isPartnerTypeDeclaration) {
                    $data.partner.identifierType = ($data.children[a].nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
                    $data.partner.identifier = ($data.children[a].nationality !== 'POLISH') ? $data.children[a].id : $data.children[a].identifier;
                    $data.partner.birthdate = ($data.children[a].nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.children[a].birthdate) : $filter('getDateFromIdentifier')($data.children[a].identifier);
                    $data.partner.citizenshipType = $data.children[a].nationality;

                    $data.partner.email = $data.children[a].email;
                    $data.partner.firstName = $data.children[a].firstName;
                    $data.partner.lastName = $data.children[a].lastName;
                    $data.partner.phone = $data.children[a].phone;
                } else if (isFamilyTypeDeclaration && (typeof $data.partner === 'undefined' || typeof $data.partner.firstName === 'undefined')) {
                    if (a === 0) {
                        $data.partner.identifierType = ($data.children[a].nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
                        $data.partner.identifier = ($data.children[a].nationality !== 'POLISH') ? $data.children[a].id : $data.children[a].identifier;
                        $data.partner.birthdate = ($data.children[a].nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.children[a].birthdate) : $filter('getDateFromIdentifier')($data.children[a].identifier);
                        $data.partner.citizenshipType = $data.children[a].nationality;

                        $data.partner.email = $data.children[a].email;
                        $data.partner.firstName = $data.children[a].firstName;
                        $data.partner.lastName = $data.children[a].lastName;
                        $data.partner.phone = $data.children[a].phone;

                        delete $data.children[a];
                    }
                } else {
                    $data.children[a].identifierType = ($data.children[a].nationality !== 'POLISH') ? 'OTHER' : 'PESEL';
                    $data.children[a].identifier = ($data.children[a].nationality !== 'POLISH') ? $data.children[a].id : $data.children[a].identifier;
                    $data.children[a].birthdate = ($data.children[a].nationality !== 'POLISH') ? $filter('getDateFromBirthdate')($data.children[a].birthdate) : $filter('getDateFromIdentifier')($data.children[a].identifier);
                    $data.children[a].citizenshipType = $data.children[a].nationality;
                    $data.children[a].address.city = $data.children[a].selectedItemLocalization;
                }

                if ($data.children[a]) {
                    delete $data.children[a].selectedItemLocalization;
                    delete $data.children[a].nationality;
                    delete $data.children[a].id;
                    delete $data.children[a].sameAddress;
                }
            }
        }

        $data.children = $data.children.filter(function() {return true;});

        $data.person.citizenshipType = $data.person.nationality;
        $data.person.address.city = $scope.selectedItemLocalization;
        $data.proposedDate = $scope.stateParams.proposedDate;
        $data.branch = $scope.userData.branch.name;

        if ($scope.packageWithRehabilitation) {
            $data.rehabilitation = true;
        }


        // @TODO <HEALTH2019>
        var statements = [].concat(requiredStatements, $scope.optionalStatements);
        applyStatementsToPerson($data.person, statements);
        $data.partner && applyStatementsToPerson($data.partner, statements);
        $data.children && angular.forEach($data.children, function (child) {
            applyStatementsToPerson(child, statements);
        });
        // @TODO </HEALTH2019>

        console.log($data);

// @TODO <HEALTH2019>
            healthInsuranceService.add($data, isPartnerTypeDeclaration).then(function (data) {
                if (data.status === 200) {
                    dataUser.update();
                    $scope.showPopUp('', 'Gratulacje!', 'Twoja deklaracja została zgłoszona.', 'Przejdź do listy deklaracji', 'root.home.healthInsurance.list', 'false');
                } else {
                    popUpService.showPopUpWithError(data.data, {ev: '', head: 'Zgłoszenie nieudane', content: 'Niestety nie udało się zgłosić deklaracji, skontaktuj się z administratorem.', text: '', target: ''});
                }
            });

// @TODO </HEALTH2019>
    };

    // @TODO <HEALTH2019>
    function isRequiredStatementsChecked(requiredStatements){
        var checkedRequiredStatementsCount = 0;
        var requiredAmountOfCheckedRequiredStatements = 0;

        angular.forEach(requiredStatements, function (statementsGroup) {
            requiredAmountOfCheckedRequiredStatements = requiredAmountOfCheckedRequiredStatements + statementsGroup.list.length;

            angular.forEach(statementsGroup.list, function (statement) {
                if (statement.checked) {
                    checkedRequiredStatementsCount++;
                }
            });
        });

        return checkedRequiredStatementsCount === requiredAmountOfCheckedRequiredStatements;
    }

    function applyStatementsToPerson(person, statementsGroups){
        if (!person) {
            return;
        }
        angular.forEach(statementsGroups, function (statementsGroupSingle) {
            angular.forEach(statementsGroupSingle.list, function (statement) {
                if (!statement.codeName) {
                    return;
                }

                var codeNames;

                if (Array.isArray(statement.codeName)) {
                    codeNames = statement.codeName;
                } else {
                    codeNames = [statement.codeName];
                }

                angular.forEach(codeNames, function (codeName) {
                    person[codeName] = !!statement.checked;
                });
            });
        });
    }
    // @TODO </HEALTH2019>

    $scope.showInformationObligation = function() {
        $scope.showPopUpInformationObligation('');
    }

    $scope.showPopUp = function(ev, head, content, text, target, exit) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {

        }, function() {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
    PopUpInfoCtrl.$inject = ['$scope', '$mdDialog', 'locals'];

    $scope.showPopUpInformationObligation = function(ev) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-obligation-declaration.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {

            }
        }).then(function(data) {

        }, function() {

        });
    }

    $scope.add = function(type) {
        if (type === 'PARTNER') {
            $scope.data.partner = {
                birthdate: new Date('01/01/2000'),
                selectedItemLocalization: null,
                nationality: 'POLISH',
                address: $scope.data.person.address,
                selectedItemLocalization: $scope.selectedItemLocalization,
                sameAddress: true
            };

            $scope.partner_length = 1;
            $scope.partner_block = true;

            if (!$scope.package.children) {
                $scope.children_block = true;
            }
        }

        if (type === 'CHILD') {

            $scope.data.children.push({
                birthdate: new Date('01/01/2000'),
                selectedItemLocalization: null,
                nationality: 'POLISH',
                member: 'CHILD',
                address: $scope.data.person.address,
                selectedItemLocalization: $scope.selectedItemLocalization,
                sameAddress: true
            });

            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = true;
                $scope.children_block = true;
            } else {
                if ($scope.children_length >= $scope.package.children) {
                    $scope.children_block = true;
                }
            }
        }
    }

    var getResults = function(query) {
        var deferred = $q.defer();

        statesService.dataCityLists({
            name: query
        }).then(function(data) {
            deferred.resolve(data.data);
        });

        return deferred.promise;
    };

    // ##### LOCALIZATION FILTER ##### //
    $scope.querySearchLocalization = function(query) {
        if (!query) {
            return;
        }

        return getResults(query).then(function(results) {
            return results;
        });
    };

    $scope.selectedItemLocalization  = null;
    $scope.searchTextLocalization    = null;

    $scope.selectedItemMainLocalization  = null;
    $scope.searchTextMainLocalization    = null;

    $scope.delete = function(obj) {
        if (obj === 'partner') {
            $scope.data.partner = {};
            $scope.partner_length = 0;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.partner_block = false;
            }
        } else {
            $scope.data.children.splice(obj, 1);
            $scope.children_length = Object.keys($scope.data.children).length;

            if (!$scope.package.children) {
                $scope.partner_block = false;
                $scope.children_block = false;
            } else {
                $scope.children_block = false;
            }
        }
    }

    $scope.$watch('data.person.address', function(oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = $scope.data.person.address;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = $scope.data.person.address;
                    }
                }
            }
        }
    }, true);

    $scope.$watch('selectedItemLocalization', function(oldVal, newVal) {
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].selectedItemLocalization = $scope.selectedItemLocalization;
                    }
                }
            }
        }
    }, true);

    var collection = ['data.partner.sameAddress', 'data.children[0].sameAddress', 'data.children[1].sameAddress', 'data.children[2].sameAddress', 'data.children[3].sameAddress', 'data.children[4].sameAddress', 'data.children[5].sameAddress'];
    $scope.$watchGroup(collection, function(oldVal, newVal) {
        console.log('change');
        if (oldVal !== newVal) {
            if ($scope.data.partner) {
                if ($scope.data.partner.sameAddress) {
                    $scope.data.partner.address = $scope.data.person.address;
                    $scope.data.partner.selectedItemLocalization = $scope.selectedItemLocalization;
                } else {
                    $scope.data.partner.address = {};
                    $scope.data.partner.selectedItemLocalization = null;
                }
            }

            if ($scope.data.children && $scope.data.children.length) {
                for (var a = 0; a < $scope.data.children.length; a++) {
                    if ($scope.data.children[a].sameAddress) {
                        $scope.data.children[a].address = $scope.data.person.address;
                        $scope.data.children[a].selectedItemLocalization = $scope.selectedItemLocalization;
                    } else {
                        $scope.data.children[a].address = {};
                        $scope.data.children[a].selectedItemLocalization = null;
                    }
                }
            }
        }
    });
}]);
